import { render, staticRenderFns } from "./OrganisationsSingle.vue?vue&type=template&id=7e098f3a&"
import script from "./OrganisationsSingle.vue?vue&type=script&lang=ts&"
export * from "./OrganisationsSingle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab})
